import { Dialog, DialogContent } from "@/components/ui/dialog";
import { FileUp } from "lucide-react";
import PropTypes from "prop-types";

const FileUpdateModal = ({
  isOpen,
  existingFiles,
  newFiles,
  softDeletedFiles,
  onCancel,
  onUploadNew,
  onUploadAll,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="max-w-lg" hideCloseButton>
        <div className="mb-4 flex items-center">
          <div className="flex-shrink-0">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-subtle">
              <FileUp className="text-primary-emphasis" size={20} />
            </div>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-bold text-foreground">Files Already Exist</h3>
            <p className="text-sm text-muted-foreground">
              {existingFiles.length} file(s) already exist in this case
            </p>
          </div>
        </div>

        <div className="mb-6">
          <div className="max-h-32 overflow-y-auto rounded-lg bg-surface-subtle p-4">
            {existingFiles.map((item, index) => (
              <div
                key={index}
                className="mb-2 flex items-center text-sm text-muted-foreground last:mb-0"
              >
                <div className="mr-3 h-2 w-2 rounded-full bg-destructive"></div>
                <span className="font-medium">{item.file.bucket_url.split("/").pop()}</span>
              </div>
            ))}
          </div>
        </div>

        {(newFiles.length > 0 || softDeletedFiles.length > 0) && (
          <div className="mb-6">
            <p className="mb-3 text-sm font-medium text-muted-foreground">Files to be uploaded:</p>
            <div className="max-h-24 overflow-y-auto rounded-lg bg-success-subtle p-4">
              {newFiles.map((file, index) => (
                <div
                  key={index}
                  className="mb-2 flex items-center justify-between text-sm text-muted-foreground last:mb-0"
                >
                  <div className="flex min-w-0 flex-1 items-center">
                    <div className="mr-3 h-2 w-2 flex-shrink-0 rounded-full bg-success"></div>
                    <span className="truncate font-medium">{file.newFile.name}</span>
                  </div>
                  <span className="ml-2 flex-shrink-0 rounded bg-success-subtle px-2 py-1 text-xs text-success-text">
                    new
                  </span>
                </div>
              ))}
              {softDeletedFiles.map((item, index) => (
                <div
                  key={`soft-${index}`}
                  className="mb-2 flex items-center justify-between text-sm text-muted-foreground last:mb-0"
                >
                  <div className="flex min-w-0 flex-1 items-center">
                    <div className="mr-3 h-2 w-2 flex-shrink-0 rounded-full bg-primary"></div>
                    <span className="truncate font-medium">{item.newFile.name}</span>
                  </div>
                  <span className="ml-2 flex-shrink-0 rounded bg-primary-subtle px-2 py-1 text-xs text-primary-emphasis">
                    restored
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="flex min-w-[400px] gap-3">
          <button
            onClick={onCancel}
            className="flex-1 whitespace-nowrap rounded-lg border border-input px-4 py-2 text-muted-foreground transition-colors hover:bg-surface-subtle hover:text-foreground"
          >
            Cancel
          </button>
          <button
            onClick={onUploadNew}
            className="flex-1 whitespace-nowrap rounded-lg bg-foreground px-4 py-2 text-white transition-colors hover:bg-foreground/90"
          >
            Upload New
          </button>
          <button
            onClick={onUploadAll}
            className="flex-1 whitespace-nowrap rounded-lg bg-primary px-4 py-2 text-white transition-colors hover:bg-primary-hover"
          >
            Upload All
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

FileUpdateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  existingFiles: PropTypes.array.isRequired,
  newFiles: PropTypes.array.isRequired,
  softDeletedFiles: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  onUploadNew: PropTypes.func.isRequired,
  onUploadAll: PropTypes.func.isRequired,
};

export default FileUpdateModal;
